import { render, staticRenderFns } from "./CreateProductModal.vue?vue&type=template&id=0f48c835&"
import script from "./CreateProductModal.vue?vue&type=script&lang=js&"
export * from "./CreateProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports